var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-wrapper",style:(_vm.cssVars)},[_c('b-alert',{staticClass:"alert-message",staticStyle:{"width":"35em","z-index":"2000"},attrs:{"variant":_vm.variant,"dismissible":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.alertState.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }